<template>
  <div>
    <drawer :drawerStatus.sync="status" @close="close" @submit="submit">
      <template slot="title">
        <div class="draw-title">
          <h3>模板分类</h3>
          <p>模板分类最少1个，最多10个</p>
        </div>
      </template>
      <div slot="content">
        <el-form>
          <vuedraggable v-model="parent" @end="end">
                <div
                  draggable="true"
                  class="banner-f-item"
                  v-for="(item, key) in list"
                :key="key"
                  :class="checkedArr.includes(key) ? 'banner-error' : ''"
                >
              <!--
                @dragstart="handleDragStart($event, item, key)"
                @dragover.prevent="handleDragOver($event, item, key)"
                @dragenter="handleDragEnter($event, item, key)"
                @dragend="handleDragEnd($event, item, key)"
              -->
                <el-form-item>
                  <div class="b-f-title">
                    <p
                      class="l"
                    >
                      <span class="iconfont icon-weibiaoti-1-04"></span>
                      模板分类{{ key + 1 }}
                    </p>
                    <el-button
                      type="text"
                      class="r default del"
                      @click="removeBanner(key)"
                      >删除</el-button
                    >
                  </div>
                  <div class="banner-con">
                    <div class="b-c-left">
                      <p>
                        标题:
                        <template v-if="!item.name_edit_status">
                          <span @click.stop="itemTextStatus(item, key)">{{
                            item.name
                          }}</span>
                        </template>

                        <el-input
                          v-else
                          type="text"
                          v-focus
                          maxlength="6"
                          @blur="item.name_edit_status = false"
                          v-model.trim="item.name"
                        />
                      </p>
                      <p>
                        模板: 已选择
                        {{ item.count || 0 }}
                        个
                      </p>
                    </div>
                    <div class="b-c-right bottom">
                      <el-button
                        type="text"
                        class="error"
                        @click.stop="removeAll(key)"
                        >清空</el-button
                      >
                      <el-button type="text" @click.stop="openDialog(key)"
                        >添加</el-button
                      >
                    </div>
                  </div>
                  <p class="error-text" v-if="checkedArr.includes(key)">
                    设置不完整
                  </p>
                </el-form-item>
              </div>
          </vuedraggable>
          <el-form-item class="form-btn">
            <el-button
              type="primary"
              class="add-banner-btn"
              v-if="list.length < maxLen"
              @click.stop="addBanner"
              >添加模板分类</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </drawer>
    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      width="800px"
      top="1vh"
      class="dt-dialog"
      @open="open"
      @close="dialogClose"
    >
      <div class="dialog-body" v-loading="loadingDialogStatus">
        <div class="dialog-title">
          <h4>模板分类设置</h4>
        </div>
        <div style="position: relative">
          <div class="search-template">
            <el-input
              type="text"
              v-model.trim="template.keywords"
              placeholder="请输入名称查询模板"
              @keyup.enter.native="handleClick"
            >
              <i
                slot="suffix"
                @click="handleClick(false)"
                :class="
                  !template.keywords
                    ? 'el-input__icon el-icon-search'
                    : 'el-input__icon el-icon-close'
                "
              ></i>
            </el-input>
          </div>
          <el-tabs v-model="activeName" @tab-click="handleClick(false)">
            <el-tab-pane label="所有模板" name="one">
              <div class="dt-content">
                <el-scrollbar style="height: 100%; overflow-x: hidden">
                  <ul v-if="imageList.length">
                    <li
                      v-for="(item, index) in imageList"
                      :key="item.id"
                      @click.stop="checkedHref(item, index)"
                      class="image-li"
                    >
                      <div class="dl-image">
                        <img :src="item.cover_url" />
                      </div>
                      <div class="active-box" v-if="item.status">
                        <i class="iconfont icon-yes"></i>
                      </div>
                      <p class="text-hidden">{{ item.name }}</p>
                    </li>
                  </ul>
                  <no-content v-else></no-content>
                </el-scrollbar>
              </div>
              <div class="pagi">
                <span
                  style="position: absolute; top: 18px; left: 0"
                  v-if="imageList.length"
                >
                  <el-checkbox
                    :indeterminate="isIndeterminate"
                    v-model="checkAll"
                    @change="handleCheckAllChange"
                    >当页全选</el-checkbox
                  ></span
                >
                <Pagination
                  v-if="Pagination.total"
                  @handleCurrentChange="handleCurrentChange"
                  :Pagination="Pagination"
                />
              </div>
            </el-tab-pane>
            <el-tab-pane label="已选模板" name="two">
              <div class="dt-content checked-img-content">
                <el-scrollbar style="height: 100%; overflow-x: hidden">
                  <ul v-if="checkedImageList.length">
                    <template v-for="(item, index) in checkedImageList">
                      <li
                        v-if="item.searchStatus"
                        :key="item.id"
                        class="image-li"
                      >
                        <div class="dl-image">
                          <img :src="item.cover_url" />
                          <div class="action">
                            <el-popover
                              placement="bottom"
                              width="276"
                              ref="popver"
                              class="action-add"
                              @show="popverShow(index)"
                            >
                              <div class="sort-box">
                                <div class="sb-top">
                                  <span @click.stop="actionUp(item, index)"
                                    ><i class="el-icon-top"></i>上移</span
                                  >
                                  <span @click.stop="actionDown(item, index)"
                                    ><i class="el-icon-bottom"></i>下移</span
                                  >
                                  <span @click.stop="actionTop(item, index)"
                                    ><i class="el-icon-upload2"></i>置顶</span
                                  >
                                  <span @click.stop="actionBottom(item, index)"
                                    ><i class="el-icon-download"></i>置底</span
                                  >
                                </div>
                                <hr />
                                <div class="sb-bottom">
                                  <span
                                    >当前位置:
                                    <el-input
                                      type="text"
                                      v-model.trim="checkedTempIndex"
                                      @blur="inputBlur(item, index)"
                                  /></span>
                                </div>
                              </div>
                              <p slot="reference">排序</p>
                            </el-popover>
                            |
                            <p
                              class="action-remove"
                              @click.stop="deleteTemplate(index)"
                            >
                              删除
                            </p>
                          </div>
                        </div>

                        <p class="text-hidden">{{ item.name }}</p>
                      </li>
                    </template>
                  </ul>
                  <no-content v-else />
                </el-scrollbar>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>

        <div class="dialog-footer" style="text-align: center">
          <el-button
            @click.stop="dialogVisible = false"
            class="cancel-btn"
            style="margin-right: 40px"
          >
            取 消
          </el-button>
          <el-button
            type="primary"
            class="confirm-btn"
            @click.stop="checkedImageSubmit"
          >
            确 定
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Drawer from "@/components/common/drawer.vue";
import { HomeSetting } from "@/config/axios/new_api";
import mixins from "@/config/mixin/index";
import NoContent from "../../../../../components/common/noContent.vue";
import vuedraggable from 'vuedraggable'
export default {
  props: {
    status: {
      type: Boolean,
      default: false,
    },
    parent: {
      type: Array,
      default: () => [],
    },
    checkedArr: {
      type: Array,
      default: () => [],
    },
  },
  mixins: [mixins],
  components: { Drawer, NoContent, vuedraggable },
  data() {
    return {
      loadingDialogStatus: false,
      maxLen: 10,
      visible: false, // action弹出框 状态
      dialogVisible: false,
      activeName: "one",
      checkedKey: null,
      checkedTempIndex: "",
      // list: [],
      dragging: null,
      imageList: [],
      checkedImageList: [], // 已选模板
      template: {
        keywords: "",
        home_template_class_id: "",
      },
      isIndeterminate: false,
      checkAll: false,
      dragIndex: null
    };
  },
  computed: {
    // list: {
    //   return [...this.parent]
    // },
    list() {
      return this.parent;
    },
  },
  watch: {
    checkedTempIndex: function (newVal) {
      if (newVal.indexOf("0") === 0) {
        newVal = "";
      }
      this.checkedTempIndex = newVal.replace(/[^0-9]/gi, "");
    },
  },
  methods: {
    end () {
      this.$emit("editTemp", this.list);
    },
    getTemplate() {
      // 模板分类
      let data = {
        keyword: encodeURIComponent(this.template.keywords),
        ...this.Pagination,
        // home_template_class_id: ,
      };
      this.loadingDialogStatus = true;
      HomeSetting.templateList(data).then((res) => {
        this.loadingDialogStatus = false;
        let num = 0;
        if (res.data && res.data.pagination.total) {
          this.imageList = res.data.data.map((item) => {
            let info = this.checkedImageList;
            item.status = false;
            if (info.length) {
              for (let i = 0; i < info.length; i++) {
                if (info[i].id === item.id) {
                  item.status = true;
                }
              }
            }
            if (item.status) {
              num++;
            }
            return item;
          });
          this.checkAll = num > 0;
          this.isIndeterminate = num > 0 && num < this.imageList.length;
          this.Pagination.total = res.data.pagination.total;
        } else {
          this.Pagination.total = 0;
          this.Pagination.page = 1;
          this.imageList = [];
        }
      });
    },
    handleCheckAllChange(val) {
      // 列表全选
      // this.checkedCities = val ? cityOptions : [];
      if (val) {
        for (let i = 0; i < this.imageList.length; i++) {
          if (!this.imageList[i].status) {
            this.imageList[i].status = true;
            this.checkedImageList.push(this.imageList[i]);
          }
        }
      } else {
        for (let i = 0; i < this.imageList.length; i++) {
          if (this.imageList[i].status) {
            this.imageList[i].status = false;
          }
          for (let b = this.checkedImageList.length - 1; b >= 0; b--) {
            if (this.checkedImageList[b].id === this.imageList[i].id) {
              this.checkedImageList.splice(b, 1);
            }
          }
        }
      }
      this.isIndeterminate = false;
    },
    getCheckedSearch() {
      // 查询已有模板
      this.checkedImageList = this.checkedImageList.map((item) => {
        if (this.template.keywords === "") {
          item.searchStatus = true;
        }
        if (item.name.indexOf(this.template.keywords) === -1) {
          item.searchStatus = false;
        } else {
          item.searchStatus = true;
        }
        return item;
      });
    },
    // 打开文件夹模板弹出框
    openDialog(key) {
      debugger;
      this.dialogVisible = true;
      this.checkedKey = key;
      this.template.home_template_class_id = this.list[key].id;
    },
    handleClick(status = true) {
      // 切换table
      if (!status) {
        this.template = {
          keywords: "",
          home_template_class_id: "",
        };
        this.resetCurrent();
      }
      if (this.activeName === "one") {
        this.getTemplate();
      } else {
        this.getCheckedSearch();
      }
    },
    open() {
      // 打开弹出框 获取数据
      let data = this.list[this.checkedKey].template_info.slice(0);
      this.checkedImageList = data.map((item) => {
        item.searchStatus = true;
        item.checkedStatus = true;
        return item;
      });
      this.Pagination.page = 1;
      this.getTemplate();
    },
    close() {
      this.checkedArr = [];
      this.checkedKey = null;

      this.$emit("close", false);
    },
    dialogClose() {
      // this.list[this.checkedKey].template_info = this.checkedImageList;
      // this.list[this.checkedKey].count = this.checkedImageList.length;
      this.template.keywords = "";
      this.activeName = "one";
    },
    checkedImageSubmit() {
      debugger;
      this.list[this.checkedKey].template_info = this.checkedImageList;
      this.list[this.checkedKey].count = this.checkedImageList.length;
      this.$emit("editTemp", this.list);
      this.dialogVisible = false;
    },
    checkedHref(item) {
      // 选中图片 传入模板分类template_info里面
      // let info = this.list[this.checkedKey].template_info;
      let status = this.checkedImageList.some((i) => i.id === item.id);
      item.status = false;
      if (status) {
        for (let i = this.checkedImageList.length - 1; i >= 0; i--) {
          if (this.checkedImageList[i].id === item.id) {
            this.checkedImageList.status = false;
            this.checkedImageList.splice(i, 1);
            // this.imageList[index].status = false;
            break;
          }
        }
      } else {
        this.checkedImageList.unshift(item);
        item.status = true;
        // this.imageList[index].status = true;
      }
      // 全选状态  先判断选中数组里面和当前数组匹配的ID数据
      let num = this.imageList.length;
      let checkedNum = 0;
      this.checkedImageList.map((item) => {
        for (let i = 0; i < this.imageList.length; i++) {
          if (this.imageList[i].id === item.id) {
            checkedNum += 1;
          }
        }
        return item;
      });

      this.checkAll = num === checkedNum;
      this.isIndeterminate =
        checkedNum > 0 && checkedNum < this.imageList.length;
    },
    addBanner(e) {
      this.buttonBlur(e);
      this.$emit("editTemp", this.list);
      this.$emit("add");
    },
    saveBanner() {
      // 保存轮播图 需要判断所有的属性是否为空， 为空则展示错误边框
      this.$emit("save");
    },
    removeBanner(key) {
            this.$emit("editTemp", this.list);
      this.$emit("remove", key);
    },

    itemTextStatus(item) {
      item.name_edit_status = true;
    },

    actionTop(item, index) {
      this.checkedImageList.splice(index, 1);
      this.checkedImageList.unshift(item);
      this.doClose(index);
    },
    actionBottom(item, index) {
      this.checkedImageList.splice(index, 1);
      this.checkedImageList.push(item);
      this.doClose(index);
    },
    actionUp(item, index) {
      if (index === 0) {
        this.doClose(index);
        return;
      }
      this.checkedImageList.splice(index, 1);
      this.checkedImageList.splice(index - 1, 0, item);
      // this.checkedImageList.(item);
      this.doClose(index);
    },
    actionDown(item, index) {
      if (this.checkedImageList - 1 === index) {
        this.doClose(index);
        return;
      }
      this.checkedImageList.splice(index, 1);
      this.checkedImageList.splice(index + 1, 0, item);
      this.doClose(index);
    },
    popverShow(index) {
      this.checkedTempIndex = `${index + 1}`;
    },
    inputBlur(item, index) {
      if (this.checkedTempIndex != index + 1) {
        this.checkedImageList.splice(index, 1);
        this.checkedImageList.splice(this.checkedTempIndex - 1, 0, item);
      }
      this.doClose(index);
    },
    doClose() {
      for (let i = 0; i < this.$refs.popver.length; i++) {
        this.$refs.popver[i].doClose();
      }
    },
    deleteTemplate(index) {
      // 删除模板
      this.$confirm("此操作将删除该模板, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.checkedImageList.splice(index, 1);
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // });
        });
    },
    handleCurrentChange(val = 1) {
      this.Pagination.page = val;
      this.getTemplate();
    },
    removeAll(index) {
      // 清空当前下的所有模板
      let obj = this.list[index];
      obj.template_info = [];
      obj.count = 0;
      this.$emit("editTemp", this.list);
      this.$emit("update", index, obj);
    },

    handleDragStart(e, item, index) {
      this.dragging = item;
      this.dragIndex = index;
    },
    handleDragEnd() {
      this.dragging = null;
      this.dragIndex =  '';
    },
    //首先把div变成可以放置的元素，即重写dragenter/dragover
    handleDragOver(e) {
      e.dataTransfer.dropEffect = "move"; // e.dataTransfer.dropEffect="move";//在dragenter中针对放置目标来设置!
    },
    handleDragEnter(e, item, index) {
      e.dataTransfer.effectAllowed = "move"; //为需要移动的元素设置dragstart事件
      if (item === this.dragging) {
        return;
      }
      if (this.dragIndex !== index) {
        const moving = this.list[this.dragIndex];
        this.list.splice(this.dragIndex, 1);
        this.list.splice(index, 0, moving);
        // 排序变化后目标对象的索引变成源对象的索引
        this.dragIndex = index;
      }

      // const newItems = [...this.list];
      // const src = newItems.indexOf(this.dragging);
      // const dst = newItems.indexOf(item);
      // newItems.splice(dst, 0, ...newItems.splice(src, 1));

      // this.$emit("editTemp", newItems);
    },
  },
};
</script>

<style lang="scss" scoped>
.banner-f-item {
  width: 272px;
  height: 120px;
  background: #fff;
  padding: 16px 20px 0;
  border-radius: 8px;
  margin-bottom: 14px !important;
  transition: all linear 1s;
  &.banner-error {
    border: 1px solid red;
    margin-bottom: 36px !important;
  }
  .b-f-title {
    height: 44px;
    line-height: 30px;
    width: 100%;
    padding-bottom: 14px;
    // h3 {
    //   float: left;
    // }
    p {
      color: #3b3946;
    }
    span {
      font-weight: 400;
      color: #aaaaa1;
    }
  }
}
.banner-con {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .b-c-left {
    p {
      line-height: 28px;
      height: 28px;
      font-size: 14px;
      color: #666;
      display: flex;
      span {
        display: inline-block;
        width: 120px;
        height: 28px;
      }
    }
  }
}
.b-c-right {
  display: flex;
  height: 56px;
  justify-content: center;
  align-items: flex-end;
  padding: 8px 0;
  // .avatar-uploader {
  //   width: 68px;
  //   height: 68px;
  //   background: #f3f3f3;
  //   border-radius: 8px;
  //   border: 1px solid #dddddd;
  //   .el-icon-plus {
  //     font-size: 22px;
  //     line-height: 68px;
  //     height: 68px;
  //     width: 68px;
  //   }
  // }
}
.add-banner-btn {
  width: 272px;
  height: 40px;
  // background: linear-gradient(180deg, #646470 0%, #3c3c4b 100%);
  // border-radius: 8px;
  // color: #fff;
  // &:hover {
  //   color: #fff;
  // }
  // &:active {
  //   color: #fff;
  // }
  // &:link {
  //   color: #fff;
  // }
}
.dt-content {
  width: 700px;
  height: 434px;
  border-radius: 8px;
  border: 1px solid #dedede;
  &.checked-img-content {
    height: 474px;
    margin-bottom: 40px;
  }
  ul {
    display: flex;
    flex-wrap: wrap;
    padding: 24px;
  }
  li {
    width: 120px;
    height: 150px;
    text-align: center;
    border-radius: 8px;
    margin-right: 12px;
    cursor: pointer;
    background: #fff;
    transition: all 0.3s;
    position: relative;
    &.folder-li {
      height: 120px;
      .dl-image {
        height: auto;
      }
    }
    .active-box {
      position: absolute;
      left: 0;
      top: 0;
      width: 120px;
      height: 120px;
      background: rgba(0, 0, 0, 0.5);
      border-radius: 8px;
      cursor: pointer;
      .icon-yes {
        color: #78cd47;
        line-height: 120px;
        font-size: 27px;
      }
    }
    &:nth-child(5n) {
      margin-right: 0;
    }
    .dl-image {
      width: 120px;
      height: 120px;
      position: relative;
      &:hover {
        .action {
          display: flex;
        }
      }
      .action {
        position: relative;
        top: -125px;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        align-content: center;
        justify-content: center;
        background: rgba(0, 0, 0, 0.5);
        border-radius: 8px;
        color: #fff;
        padding-top: 45px;
        line-height: 30px;
        display: none;
        .action-add {
          margin-right: 5px;
        }
        .action-remove {
          margin-left: 5px;
        }
      }
    }
    &.image-li {
      .dl-image {
        border-radius: 8px;
        transition: all 0.3s;
      }
    }
    img {
      width: 100%;
      height: 120px;
      // padding: 24px 27px 0 26px;
      object-fit: scale-down;
      &.folder-img {
        width: 67px;
        height: auto;
        padding: 24px 27px 0 26px;
      }
    }
    &.folder-li:hover {
      background: $hoverColor;
    }
    &.image-li:hover .dl-image {
      background: $hoverColor;
    }

    > p {
      line-height: 30px;
      height: 30px;
    }
  }
}
.pagi {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
</style>

<style lang="scss">
.dialog-title {
  text-align: center;
  margin-bottom: 40px;
}
.el-dialog__body {
  padding: 40px 50px;
}
.dt-dialog {
  .el-dialog {
    height: 735px;
    border-radius: 8px;
    .search-template {
      position: absolute;
      right: 0;
      top: -15px;
      z-index: 100;

      .el-icon-search {
        color: #3d3d44;
      }
    }
  }
}
.sb-bottom {
  width: 100%;
  height: 30px;
  .el-input {
    width: 176px;
    .el-input__inner {
      border: none;
      border-bottom: 1px solid #dedede;
      line-height: 30px;
      border-radius: 0;
    }
  }
}
.sb-top {
  display: flex;
  justify-content: space-around;
  span {
    cursor: pointer;
    &:hover {
      color: $activeColor;
    }
  }
}
.b-c-left {
  .el-input {
    width: 120px;
    border: none;
    .el-input__inner {
      border: none;
      border-bottom: 1px solid #dedede;
      border-radius: 0;
      height: 22px;
      line-height: 22px;
    }
  }
}
</style>
